import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { formatTrendTick, formatTrendTooltipLabel, formatUsd } from "../formatters";

const getTrendSeriesLabel = (seriesKey) => {
  if (seriesKey === "totalValueLockedUSD") {
    return "Total Value Locked (USD)";
  }

  if (seriesKey === "volumeUSD") {
    return "Snapshot Volume (USD)";
  }

  if (seriesKey === "feesUSD") {
    return "Snapshot Fees (USD)";
  }

  return "Value (USD)";
};

const ReddicksTrendCard = ({ trendRows, isLoading, hasCachedData }) => {
  const noRows = !Array.isArray(trendRows) || trendRows.length === 0;

  return (
    <Card className="leaderboard-surface-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">
          RSwap Network Trend (TVL + Snapshot Volume)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && !hasCachedData ? (
          <div className="reddicks-chart-empty">Loading trend data...</div>
        ) : noRows ? (
          <div className="reddicks-chart-empty">
            Trend data is unavailable for the selected source.
          </div>
        ) : (
          <div className="reddicks-chart-shell">
            <ResponsiveContainer width="100%" height={320}>
              <ComposedChart data={trendRows}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(0 15% 18%)" />
                <XAxis
                  dataKey="date"
                  tickFormatter={formatTrendTick}
                  stroke="hsl(0 0% 60%)"
                  minTickGap={32}
                />
                <YAxis
                  yAxisId="left"
                  tickFormatter={(value) =>
                    formatUsd(value, { compact: true, fallback: "$0" })
                  }
                  stroke="hsl(0 0% 60%)"
                  width={80}
                />
                <YAxis
                  yAxisId="right"
                  orientation="right"
                  tickFormatter={(value) =>
                    formatUsd(value, { compact: true, fallback: "$0" })
                  }
                  stroke="hsl(0 0% 60%)"
                  width={80}
                />
                <YAxis yAxisId="fees" hide />
                <Tooltip
                  labelFormatter={formatTrendTooltipLabel}
                  formatter={(value, _seriesName, context) => {
                    const seriesKey = context?.dataKey;

                    return [
                      formatUsd(value, { fallback: "$0.00" }),
                      getTrendSeriesLabel(seriesKey),
                    ];
                  }}
                  contentStyle={{
                    background: "hsl(0 8% 10%)",
                    border: "1px solid hsl(0 15% 22%)",
                    borderRadius: "0.65rem",
                  }}
                />
                <Legend />
                <Area
                  yAxisId="left"
                  type="monotone"
                  dataKey="totalValueLockedUSD"
                  name="TVL Snapshot (USD)"
                  stroke="hsl(190 80% 60%)"
                  fill="hsl(190 80% 45% / 0.22)"
                  strokeWidth={2}
                />
                <Line
                  yAxisId="right"
                  type="monotone"
                  dataKey="volumeUSD"
                  name="Volume Snapshot (USD)"
                  stroke="hsl(0 75% 58%)"
                  strokeWidth={2}
                  dot={false}
                />
                <Bar
                  yAxisId="fees"
                  dataKey="feesUSD"
                  name="Fees Snapshot (USD)"
                  fill="hsl(46 92% 58% / 0.65)"
                  maxBarSize={12}
                  radius={[3, 3, 0, 0]}
                />
              </ComposedChart>
            </ResponsiveContainer>
            <p className="reddicks-chart-note">
              Blue area = TVL snapshots, red line = volume snapshots, gold bars = fee snapshots.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ReddicksTrendCard;
